/* Rogue Nest Theme JS */
document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile menu toggle ──────────────────────────────────────
  const toggle = document.getElementById('mobileToggle');
  const mobileMenu = document.getElementById('mobileMenu');
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
    });
  }

  // ── Scroll reveal ────────────────────────────────────────────
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) e.target.classList.add('revealed');
    });
  }, { threshold: 0.07 });
  document.querySelectorAll('.reveal').forEach(el => obs.observe(el));

  // ── Cart count update ────────────────────────────────────────
  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-num').forEach(el => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});
  }
  refreshCart();

  // ── Add to cart buttons ──────────────────────────────────────
  document.querySelectorAll('.add-btn').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const card = this.closest('a.prod-card');
      if (!card) return;
      const url = card.getAttribute('href');
      if (!url) return;
      fetch(url + '.js')
        .then(r => r.json())
        .then(product => {
          const variantId = product.variants[0].id;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
        })
        .then(() => {
          refreshCart();
          this.textContent = '✓';
          this.style.background = 'var(--lime)';
          this.style.color = 'var(--ink)';
          setTimeout(() => {
            this.textContent = '+';
            this.style.background = '';
            this.style.color = '';
          }, 1500);
        })
        .catch(() => {
          if (card.href) window.location.href = card.href;
        });
    });
  });

  // ── Quantity adjuster (product page) ────────────────────────
  window.adjustQty = function (delta) {
    const input = document.getElementById('qtyInput');
    if (input) input.value = Math.max(1, parseInt(input.value || 1) + delta);
  };

  // ── Variant selector sync ────────────────────────────────────
  const variantSelects = document.querySelectorAll('.variant-opt input');
  const hiddenSelect = document.querySelector('select[name="id"]');
  if (variantSelects.length && hiddenSelect) {
    variantSelects.forEach(input => {
      input.addEventListener('change', () => {
        const selected = Array.from(variantSelects)
          .filter(i => i.checked)
          .map(i => i.value);
        const opts = Array.from(hiddenSelect.options);
        opts.forEach(opt => {
          const match = selected.every(val => opt.text.includes(val));
          if (match) {
            hiddenSelect.value = opt.value;
          }
        });
      });
    });
  }

  // ── Sticky header shadow ─────────────────────────────────────
  const navWrap = document.querySelector('.nav-wrap');
  if (navWrap) {
    window.addEventListener('scroll', () => {
      navWrap.style.boxShadow = window.scrollY > 10
        ? '0 2px 24px rgba(0,0,0,0.08)'
        : 'none';
    });
  }

});
